export function PolylineIcon(props: React.SVGProps<SVGSVGElement>): JSX.Element {
  return (
    <svg width='32' height='32' viewBox='0 0 32 32' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <line
        x1='10.0029'
        y1='6.44339'
        x2='25.1084'
        y2='13.9962'
        stroke='currentColor'
        strokeLinecap='round'
        strokeDasharray='4 3'
      />
      <line
        x1='14.9306'
        y1='24.6765'
        x2='23.3448'
        y2='21.0704'
        stroke='currentColor'
        strokeLinecap='round'
        strokeDasharray='4 3'
      />
      <circle cx='4.66797' cy='4.66699' r='2.5' stroke='currentColor' />
      <circle cx='28.668' cy='18' r='2.5' stroke='currentColor' />
      <circle cx='10' cy='27.333' r='2.5' stroke='currentColor' />
    </svg>
  )
}
